export const site = {
  name: 'VentBudEngineering',
  legalName: 'VentBudEngineering Company',
  defaultTitle: 'VentBudEngineering',
  defaultDescription:
    'VentBudEngineering — виготовлення комплектуючих для систем вентиляції та кондиціонування повітря, монтажні та ремонтні роботи в Україні.',
  defaultLocale: 'uk_UA',
  defaultOgImagePath: '/logo512.png',
  address: {
    country: 'UA',
    locality: 'Київ',
    streetAddress: 'вулиця Дубровицька, 28, Офіс 311'
  },
  contacts: {
    email: 'vbe23@ukr.net',
    phone: '+380963687027'
  }
} as const

